<template>
  <div class="page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      class="nav-bar"
      :title="$t('auth.login')"
      left-arrow
      @click-left="back()"
    >
      <template #left>
        <div class="home-btn" @click="goHome()">
          <van-icon name="wap-home-o" color="#fff" size="22PX" />
        </div>
      </template>
     <template #right>
        <div class="language" @click="$router.push('/language')">
          <van-icon name="exchange" color="#fff" size="24PX" />
        </div>
      </template>
    </van-nav-bar>

    <!-- 主要内容区 -->
    <div class="content">
      <!-- Logo -->
      <div class="logo-wrapper">
        <img src="/img/logo.png" class="logo" alt="logo" style="width: 55px;height: 55px;;"/>
        <div class="app-name">汽水音乐</div>
      </div>

      <!-- 登录表单 -->
      <div class="loginForm">
        <!-- 账号输入 -->
        <van-field
          v-model="username"
          clearable
          class="input"
          :placeholder="$t('auth.username_place')"
        >
          <template #left-icon>
            <van-icon name="user-o" color="#999" size="22PX" />
          </template>
        </van-field>

        <!-- 密码输入 -->
        <van-field
          v-model="password"
          :type="passwordType"
          class="input"
          :placeholder="$t('auth.pwd_place')"
        >
          <template #left-icon>
            <van-icon name="lock" color="#999" size="22PX" />
          </template>
          <template #right-icon>
            <van-icon
              :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
              color="#999"
              size="22PX"
              @click="switchPasswordType"
            />
          </template>
        </van-field>

        <!-- 记住密码 -->
        <div class="remember-row">
          <van-checkbox v-model="remember" icon-size="18PX" checked-color="#7C4DFF">
            {{ $t("auth.top31") }}
          </van-checkbox>
        </div>

        <!-- 登录按钮 -->
        <van-button
          class="login-btn"
          block
          color="#7C4DFF"
          @click="doLogin()"
        >
          {{ $t("auth.login") }}
        </van-button>

        <!-- 注册按钮 -->
        <van-button
          class="register-btn"
          block
          color="#7C4DFF"
          @click="toRegister()"
        >
          {{$t("auth.no_account")}}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      remember: false,
      lang: "",
    };
  },
  mounted() {
    this.lang = this.$t("auth.lang");
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    goHome() {
      this.$router.push("/");
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (!this.username) {
        this.$toast(this.$t("auth.username_place"));
        return;
      }
      if (!this.password) {
        this.$toast(this.$t("auth.pwd_place"));
        return;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang="less" scoped>
.page {
  min-height: 100VH;
  background: #fff;
}

.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #fff;
    font-size: 18PX;
    font-weight: 500;
  }
  :deep(.van-icon) {
    color: #fff;
  }
}

/* 首页按钮 */
.home-btn {
  display: flex;
  align-items: center;
  gap: 4PX;
  cursor: pointer;
  .home-text {
    font-size: 14PX;
    color: #fff;
  }
}

/* 语言切换图标 */
.language {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 24PX;
}

.content {
  padding: 40PX 24PX;
}

.logo-wrapper {
  text-align: center;
  margin-bottom: 30PX;
  .logo {
    width: 80PX;
    height: 80PX;
    object-fit: contain;
  }
  .app-name {
    margin-top: 10PX;
    font-size: 20PX;
    font-weight: bold;
    color: #333;
  }
}

.loginForm {
  .input {
    margin-bottom: 18PX;
    border: 1PX solid #ddd;
    border-radius: 8PX;
    background: #fff;
    padding: 15PX 12PX;
    :deep(.van-field__control) {
      font-size: 15PX;line-height: 32PX;
      color: #333;
    }
  }

  .remember-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24PX;
    :deep(.van-checkbox__label) {
      color: #666;
      font-size: 14PX;
    }
  }

  .login-btn {
    height: 48PX;
    border-radius: 8PX;
    font-size: 16PX;
    font-weight: bold;
    margin-bottom: 16PX;
  }

  .register-btn {
    height: 48PX;
    border-radius: 8PX;
    font-size: 16PX;
    font-weight: bold;
    background: #fff !important;
    color: #7C4DFF !important;
    border: 1PX solid #7C4DFF;
  }
}
::v-deep .van-field__control {
  font-size: 14PX;
  color: #333;
}

/* 修改 placeholder 字体大小 */
::v-deep  .van-field__control::placeholder {
  font-size: 14PX;
  color: #999;
}
</style>